// NPM Imports
import React from "react";
import { Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Dropdown = props => {
  const { options, toolTip } = props;
  return (
    <div className={`dropdown-wrapper ${options.className}`}>
      <span
        data-test="dropdown-opportunity-sort-icon"
        className="dropdown-icon"
        onClick={props.showDropdownHandler}
        onKeyPress={props.showDropdownHandler}
        role="button"
        tabIndex="0">
        {toolTip ? (
          <Tooltip
            align={toolTip.align}
            mouseLeaveDelay={0}
            overlay={toolTip.overlay}
            placement={toolTip.placement}>
            <FontAwesomeIcon icon={["far", `${options.icon}`]} />
          </Tooltip>
        ) : (
          <FontAwesomeIcon
            icon={[
              `${options.iconType ? options.iconType : "far"}`,
              `${options.icon}`,
            ]}
          />
        )}
      </span>
      {props.showDropdown ? (
        <div
          className={`dropdown-options dropdown-${options.position}`}
          ref={props.dropdownRef}>
          {options.title ? (
            <span className="dropdown-subtitle">{options.title}</span>
          ) : null}
          <ul>
            {options.options.map((option, key) => (
              <li
                className={`dropdown-list ${
                  options.selectedClassNameIdent === option.argument
                    ? " is-selected "
                    : ""
                } ${option.isBottomLine ? "list-bottom-line" : ""}`}
                key={option.name}>
                <span
                  data-test="dropdown-pipeline-document-delete-button"
                  className="dropdown-custom-item"
                  onClick={
                    option.argument
                      ? () => option.action(option.argument)
                      : option.action
                  }
                  onKeyPress={() => {}}
                  role="button"
                  tabIndex={key}>
                  {option.icon ? (
                    <span className="dropdown-list-optionalicon">
                      <FontAwesomeIcon
                        icon={option.icon}
                        className={option.iconClassName}
                      />
                    </span>
                  ) : null}
                  <span>{option.name}</span>
                </span>
                <span className="dropdown-tick">
                  <FontAwesomeIcon icon={["far", "check"]} />
                </span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/commonComponents/Dropdown/index.js